/* Cocauto COC v2.2.4 — VIN et pays obligatoires sur fiche produit ; pas de service PRO externe. */
(() => {
  'use strict';
  const cfg = window.cocautoTheme || {};
  const labels = cfg.labels || {};
  const root = (cfg.root || '/').replace(/\/?$/, '/');
  const money = cents => {
    const currency = cfg.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(currency === 'EUR' ? 'fr-FR' : (document.documentElement.lang || 'fr-FR'), {style:'currency', currency}).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2) + ' €'; }
  };
  const normalize = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
  const validVIN = vin => /^[A-HJ-NPR-Z0-9]{17}$/.test(vin);
  const wmi = {
    WBA:'BMW',WBS:'BMW',WBY:'BMW',WBX:'BMW',WMW:'MINI',WAU:'AUDI',WA1:'AUDI',TRU:'AUDI',WVW:'VOLKSWAGEN',WVG:'VOLKSWAGEN',WV1:'VOLKSWAGEN',WV2:'VOLKSWAGEN',WDB:'MERCEDES',WDC:'MERCEDES',WDD:'MERCEDES',WDF:'MERCEDES',W1K:'MERCEDES',W1V:'MERCEDES',VF1:'RENAULT',VF3:'PEUGEOT',VF7:'CITROEN',VR7:'CITROEN',VR3:'PEUGEOT',ZFA:'FIAT',ZFC:'FIAT',ZAR:'ALFA ROMEO',ZFF:'FERRARI',ZAM:'MASERATI',ZHW:'LAMBORGHINI',SAL:'LAND ROVER',SAD:'JAGUAR',SAJ:'JAGUAR',ZCG:'MV AGUSTA',YS3:'SAAB',YV1:'VOLVO',YV4:'VOLVO',VSS:'SEAT',TMB:'SKODA',TM9:'SKODA',VSK:'NISSAN',SJN:'NISSAN',JN1:'NISSAN',JN8:'NISSAN',JHM:'HONDA',JH2:'HONDA',SHH:'HONDA',JTD:'TOYOTA',JT2:'TOYOTA',SB1:'TOYOTA',JTK:'TOYOTA',JMB:'MITSUBISHI',JM1:'MAZDA',JMZ:'MAZDA',KL1:'CHEVROLET',KL7:'CHEVROLET','1G1':'CHEVROLET','1GC':'CHEVROLET','1FA':'FORD','1FM':'FORD',WF0:'FORD',WFO:'FORD',SFA:'FORD','5YJ':'TESLA','7SA':'TESLA','7G2':'TESLA',WPO:'PORSCHE',WP0:'PORSCHE',WP1:'PORSCHE',SCB:'BENTLEY',SCF:'ASTON MARTIN',SMT:'TRIUMPH',VBK:'KTM',ZAP:'PIAGGIO',JKA:'KAWASAKI',JS1:'SUZUKI',JS2:'SUZUKI',JY4:'YAMAHA',JYA:'YAMAHA',MLH:'HONDA',ZDM:'DUCATI','5HD':'HARLEY DAVIDSON'
  };
  function saveVin(vin){ try { sessionStorage.setItem('cocauto_vin', JSON.stringify({vin, time: Date.now()})); } catch(_){ } }
  function readVin(){ try { const x = JSON.parse(sessionStorage.getItem('cocauto_vin') || 'null'); return x && Date.now()-x.time < 30*60*1000 ? x.vin : ''; } catch(_) { return ''; } }
  function findProduct(brand){
    const needle = normalize(brand);
    const cards = [...document.querySelectorAll('[data-coc-card]')];
    return cards.find(card => normalize(card.dataset.brand || '').includes(needle));
  }
  function categorySearch(brand){
    const card = findProduct(brand);
    if(card){ const link = card.querySelector('.coc-product-info h3 a') || card.querySelector('a'); if(link) return link.href; }
    return (cfg.search || root + 'search') + '?type=product&q=' + encodeURIComponent(brand);
  }
  function result(el,text,success){if(!el)return;el.textContent='';el.classList.toggle('is-success',!!success);el.classList.toggle('is-error',!success);el.appendChild(document.createTextNode(text));}
  document.querySelectorAll('[data-vin-form]').forEach(form => {
    const input = form.querySelector('input[name="vin"]');
    const message = form.parentElement.querySelector('[data-vin-result]') || form.nextElementSibling;
    if(!input) return;
    input.addEventListener('input',()=>{input.value=input.value.toUpperCase().replace(/\s/g,'');});
    form.addEventListener('submit', e => {
      e.preventDefault();
      const vin = input.value.trim().toUpperCase();
      if(!validVIN(vin)){result(message,(labels.vinInvalid || "Le VIN doit contenir exactement 17 lettres/chiffres, sans I, O ni Q."),false); return;}
      const brand = wmi[vin.slice(0,3)];
      if(!brand){result(message,(labels.vinUnknown || "Le format du VIN est valide, mais sa marque n’est pas reconnue par notre correspondance indicative. Utilisez la sélection manuelle."),false);return;}
      saveVin(vin);
      result(message,(labels.brandGuess || "Préfixe constructeur possiblement associé à ") + brand + (labels.notEligibility || ". Ce résultat ne confirme pas l’éligibilité au COC. "),true);
      if(message){const a = document.createElement('a'); a.href=categorySearch(brand); a.textContent=(labels.viewBrand || "Voir les certificats ") + brand + ' →'; message.appendChild(a);}
    });
  });
  document.querySelectorAll('[data-brand-form]').forEach(form => form.addEventListener('submit',e=>{
    e.preventDefault(); const q = form.querySelector('input[name="brand"]'); if(q && q.value.trim()) window.location.assign(categorySearch(q.value.trim()));
  }));

  // Catalogue : filtre sur l'ensemble des produits de la collection, puis limite à 8 cartes.
  // Les autres pages sont récupérées par la pagination native des collections Shopify.
  const catalog = document.querySelector('.coc-catalog-section');
  if(catalog){
    const MAX_RESULTS = 8;
    const COLLECTION_PAGE_SIZE = 24; // sections/collection-main-cocauto.liquid
    let category='car', query='', alpha='all', requestNumber=0, controller=null, debounceTimer=null;
    const tabs=[...catalog.querySelectorAll('[data-category-tab]')];
    const panels=[...catalog.querySelectorAll('[data-category-panel]')];
    const alphaButtons=[...catalog.querySelectorAll('[data-alpha]')];
    const searchInput=catalog.querySelector('[data-catalog-query]');
    const clear=catalog.querySelector('[data-clear-query]');
    const noresult=catalog.querySelector('[data-no-results]');
    const loading=catalog.querySelector('[data-catalog-loading]');
    const error=catalog.querySelector('[data-catalog-error]');
    const pageCache=new Map();
    const initialCards=new Map(panels.map(panel => [panel.dataset.categoryPanel,
      [...panel.querySelectorAll('[data-coc-card]')].map(card=>card.cloneNode(true))]));

    function matches(card){
      const raw=normalize(card.dataset.brand||'');
      // Ne pas prendre en compte le préfixe générique du certificat pour la lettre.
      const clean=raw.replace(/^CERTIFICAT DE CONFORMITE\s*/,'').replace(/^COC\s*/,'').trim();
      return (!query || raw.includes(query)) && (alpha==='all' || clean.startsWith(alpha));
    }
    function updateControls(){
      panels.forEach(panel=>{
        const active=panel.dataset.categoryPanel===category;
        panel.hidden=!active;panel.classList.toggle('is-active',active);
      });
      tabs.forEach(tab=>{
        const active=tab.dataset.categoryTab===category;
        tab.classList.toggle('is-active',active);
        tab.setAttribute('aria-selected',String(active));
      });
      alphaButtons.forEach(btn=>btn.classList.toggle('is-active',btn.dataset.alpha===alpha));
    }
    function showCards(panel,cards){
      const grid=panel.querySelector('.coc-product-grid');
      if(grid)grid.replaceChildren(...cards.slice(0,MAX_RESULTS).map(card=>card.cloneNode(true)));
      if(noresult)noresult.hidden=cards.length>0 || !Number(panel.dataset.productCount||0);
    }
    function stopPending(){
      requestNumber++;
      clearTimeout(debounceTimer);
      if(controller){controller.abort();controller=null;}
      if(loading)loading.hidden=true;
      if(error)error.hidden=true;
      if(noresult)noresult.hidden=true;
    }
    // Les cartes sont rendues par Shopify sur la page de collection : prix, traductions,
    // images et métachamps restent identiques à ceux du thème.
    async function loadPage(panel,page,signal){
      const collectionUrl=panel.dataset.collectionUrl;
      const key=collectionUrl+'|'+page;
      if(pageCache.has(key))return pageCache.get(key);
      const url=new URL(collectionUrl,window.location.origin);
      url.searchParams.set('page',String(page));
      const response=await fetch(url.toString(),{credentials:'same-origin',signal,headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error('Collection fetch failed ('+response.status+')');
      const html=new DOMParser().parseFromString(await response.text(),'text/html');
      const grid=html.querySelector('.coc-collection-page .coc-collection-grid');
      if(!grid)throw new Error('Collection grid unavailable');
      const cards=[...grid.querySelectorAll('[data-coc-card]')].map(card=>card.cloneNode(true));
      pageCache.set(key,cards);
      return cards;
    }
    async function filterCatalog(){
      stopPending();
      const currentRequest=requestNumber;
      const panel=panels.find(item=>item.dataset.categoryPanel===category);
      updateControls();
      if(!panel)return;

      // Sans filtre, la première sélection de 8 est conservée sans requête réseau.
      if(!query && alpha==='all'){
        showCards(panel,initialCards.get(category)||[]);
        return;
      }
      const total=Number(panel.dataset.productCount||0);
      if(!panel.dataset.collectionUrl||!total){
        showCards(panel,[]);
        return;
      }

      const firstMatches=(initialCards.get(category)||[]).filter(matches).slice(0,MAX_RESULTS);
      showCards(panel,firstMatches);
      // Si les 8 premiers produits suffisent déjà, aucun chargement nécessaire.
      if(firstMatches.length===MAX_RESULTS)return;
      if(loading)loading.hidden=false;
      if(noresult)noresult.hidden=true;
      controller=new AbortController();
      const activeSignal=controller.signal;
      const selectedCategory=category;
      const selectedQuery=query;
      const selectedAlpha=alpha;
      const found=[];
      try{
        const pageCount=Math.ceil(total/COLLECTION_PAGE_SIZE);
        for(let page=1;page<=pageCount && found.length<MAX_RESULTS;page++){
          const cards=await loadPage(panel,page,activeSignal);
          if(currentRequest!==requestNumber)return;
          // Sécurise la cohérence si un autre onglet / une autre lettre a été choisi.
          if(category!==selectedCategory||query!==selectedQuery||alpha!==selectedAlpha)return;
          for(const card of cards){
            if(matches(card))found.push(card);
            if(found.length===MAX_RESULTS)break;
          }
          showCards(panel,found);
          if(cards.length===0)break;
        }
        if(currentRequest===requestNumber){
          if(loading)loading.hidden=true;
          if(noresult)noresult.hidden=found.length>0;
        }
      }catch(err){
        if(err.name==='AbortError'||currentRequest!==requestNumber)return;
        if(loading)loading.hidden=true;
        if(noresult)noresult.hidden=true; // Ne jamais annoncer « aucun résultat » sur erreur réseau.
        if(error)error.hidden=false;
        console.warn('Cocauto catalogue:',err);
      }
    }
    tabs.forEach(tab=>tab.addEventListener('click',()=>{
      category=tab.dataset.categoryTab;
      query='';alpha='all';
      if(searchInput)searchInput.value='';
      filterCatalog();
    }));
    if(searchInput)searchInput.addEventListener('input',()=>{
      query=normalize(searchInput.value);
      stopPending();
      updateControls();
      debounceTimer=setTimeout(filterCatalog,180);
    });
    alphaButtons.forEach(btn=>btn.addEventListener('click',()=>{
      alpha=btn.dataset.alpha;
      filterCatalog();
    }));
    if(clear)clear.addEventListener('click',()=>{
      query='';if(searchInput)searchInput.value='';
      filterCatalog();searchInput?.focus();
    });
    updateControls();
  }
  document.querySelectorAll('[data-simple-filter]').forEach(input=>input.addEventListener('input',()=>{
    const grid=document.querySelector('[data-simple-filter-grid]');if(!grid)return;
    grid.querySelectorAll('[data-coc-card]').forEach(card=>card.hidden=!normalize(card.dataset.brand).includes(normalize(input.value)));
  }));
  document.querySelectorAll('[data-sort-select],[data-localization-select]').forEach(select=>select.addEventListener('change',()=>select.form && select.form.submit()));
  const mobileButton=document.querySelector('[data-mobile-menu]');
  const nav=document.querySelector('#coc-navigation');
  if(mobileButton && nav)mobileButton.addEventListener('click',()=>{const opened=nav.classList.toggle('is-open');mobileButton.setAttribute('aria-expanded',String(opened));});

  // Fiche produit : stockage local transitoire du VIN, propriétés de ligne Shopify, anti double ajout.
  document.querySelectorAll('[data-vin-product]').forEach(input=>{
    if(!input.value){ const value=readVin(); if(value)input.value=value; }
    input.addEventListener('input',()=>input.value=input.value.toUpperCase().replace(/\s/g,''));
  });
  document.querySelectorAll('[data-qty-minus]').forEach(btn=>btn.addEventListener('click',()=>{const n=btn.closest('.coc-quantity')?.querySelector('input');if(n)n.value=Math.max(1,parseInt(n.value||'1',10)-1);}));
  document.querySelectorAll('[data-qty-plus]').forEach(btn=>btn.addEventListener('click',()=>{const n=btn.closest('.coc-quantity')?.querySelector('input');if(n)n.value=Math.min(99,parseInt(n.value||'1',10)+1);}));
  document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',()=>{
    const price=select.selectedOptions[0]?.dataset.price||'';
    const box=select.closest('.coc-product-detail')?.querySelector('[data-product-price]');
    if(box && price)box.textContent=price;
  }));
  document.querySelectorAll('[data-open-delivery]').forEach(btn=>btn.addEventListener('click',()=>{
    const dialog=document.querySelector('[data-delivery-dialog]'); if(dialog && dialog.showModal) dialog.showModal();
  }));
  document.querySelectorAll('[data-dialog-close]').forEach(btn=>btn.addEventListener('click',()=>btn.closest('dialog')?.close()));

  // Panier Ajax : un SEUL POST par soumission ; chiffres à jour et suppression par clef de ligne.
  const drawer=document.querySelector('[data-cart-drawer]');
  const overlay=document.querySelector('[data-cart-overlay]');
  let opener=null;
  function openDrawer(){if(!drawer || !overlay)return; opener=document.activeElement; drawer.classList.add('is-open');drawer.setAttribute('aria-hidden','false');overlay.hidden=false;document.body.style.overflow='hidden';drawer.querySelector('[data-close-cart]')?.focus();}
  function closeDrawer(){if(!drawer||!overlay)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');overlay.hidden=true;document.body.style.overflow='';if(opener && opener.focus)opener.focus();}
  document.querySelectorAll('[data-open-cart]').forEach(btn=>btn.addEventListener('click',async()=>{await updateDrawer();openDrawer();}));
  document.querySelectorAll('[data-close-cart]').forEach(btn=>btn.addEventListener('click',closeDrawer));
  overlay?.addEventListener('click',closeDrawer);
  document.addEventListener('keydown',e=>{if(e.key==='Escape' && drawer?.classList.contains('is-open'))closeDrawer();});
  async function requestJson(url, options){
    const response=await fetch(root + url, {credentials:'same-origin',...options});
    const data=await response.json();
    if(!response.ok)throw new Error(data.description || data.message || (labels.unknownError || "Une erreur est survenue."));
    return data;
  }
  async function updateDrawer(){
    const cart=await requestJson('cart.js');
    document.querySelectorAll('[data-header-count]').forEach(el=>el.textContent=cart.item_count);
    document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent='('+cart.item_count+')');
    const total=drawer?.querySelector('[data-cart-total]');if(total)total.textContent=money(cart.total_price);
    const lines=drawer?.querySelector('[data-cart-items]');if(!lines)return;
    lines.replaceChildren();
    if(!cart.items.length){const p=document.createElement('p');p.className='coc-muted';p.textContent=(labels.cartEmpty || "Votre panier est vide.");lines.appendChild(p);return;}
    cart.items.forEach(item=>{
      const row=document.createElement('div');row.className='coc-drawer-line';
      const a=document.createElement('a');a.href=item.url;a.textContent=item.product_title;
      const price=document.createElement('span');price.textContent=item.quantity+' × '+money(item.final_price);
      const remove=document.createElement('button');remove.type='button';remove.textContent=(labels.remove || "Supprimer");remove.dataset.cartRemove=item.key;
      row.append(a,price,remove);
      lines.appendChild(row);
    });
  }
  drawer?.addEventListener('click',async e=>{
    const remove=e.target.closest('[data-cart-remove]');if(!remove)return;
    remove.disabled=true;
    try{await requestJson('cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:remove.dataset.cartRemove,quantity:0})}); await updateDrawer();}
    catch(err){alert(err.message);remove.disabled=false;}
  });
  document.querySelectorAll('form[data-coc-product-form]').forEach(form=>{
    let busy=false;
    form.addEventListener('submit', async e=>{
      const vinInput=form.querySelector('[data-vin-product]');
      const message=form.querySelector('[data-vin-product-message]');
      if(vinInput && !validVIN(vinInput.value.trim().toUpperCase())){
        e.preventDefault(); if(message)message.textContent=(labels.vinIncorrect || "Numéro VIN incorrect : 17 caractères sans I, O, Q.");vinInput.focus();return;
      }
      if(!form.reportValidity()){e.preventDefault();return;}
      e.preventDefault();
      if(busy)return;
      busy=true;
      const button=form.querySelector('[type="submit"]');const error=form.querySelector('[data-product-error]');
      if(error)error.textContent='';
      if(button)button.disabled=true;
      try{
        const formData=new FormData(form);
        await requestJson('cart/add.js',{method:'POST',body:formData});
        try{sessionStorage.removeItem('cocauto_vin');}catch(_){}
        await updateDrawer();openDrawer();
      }catch(err){if(error)error.textContent=err.message || (labels.addError || "Ajout au panier impossible.");}
      finally{busy=false;if(button)button.disabled=false;}
    });
  });
  // Offre de sortie facultative : code créé dans Shopify, aucune remise inventée.
  const promo=document.querySelector('[data-promo-modal]');
  const promoOverlay=document.querySelector('[data-promo-overlay]');
  const promoClose=()=>{if(!promo||!promoOverlay)return;promo.classList.remove('is-open');promo.setAttribute('aria-hidden','true');promoOverlay.hidden=true;document.body.style.overflow='';};
  if(promo && promoOverlay){
    const show=()=>{try{if(sessionStorage.getItem('cocauto_promo_shown'))return;sessionStorage.setItem('cocauto_promo_shown','1');}catch(_){}
      promo.classList.add('is-open');promoOverlay.hidden=false;promo.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';promo.querySelector('[data-promo-close]')?.focus();};
    if(window.matchMedia('(min-width: 900px) and (pointer: fine)').matches){
      document.addEventListener('mouseout',e=>{if(!e.relatedTarget && e.clientY <= 4)show();});
    }
    promo.querySelector('[data-promo-close]')?.addEventListener('click',promoClose);
    promoOverlay.addEventListener('click',promoClose);
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&promo.classList.contains('is-open'))promoClose();});
    promo.querySelector('[data-promo-copy]')?.addEventListener('click',async()=>{
      const code=promo.querySelector('.coc-promo-code strong')?.textContent||'';
      try{await navigator.clipboard.writeText(code);promo.querySelector('[data-promo-copy]').textContent=(labels.copied || "Copié !");}catch(_){}
    });
  }
  // Slider d'actualités : écoute déléguée, compatible avec les sections rechargées par Shopify.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-coc-news-step]');
    if (!button) return;
    const wrapper = button.closest('[data-coc-news-carousel]');
    const track = wrapper?.querySelector('.coc-news-viewport');
    if (!track) return;
    const card = track.querySelector('.coc-news-card');
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const step = (card?.getBoundingClientRect().width || track.clientWidth) + gap;
    const direction = Number(button.dataset.cocNewsStep) || 1;
    track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  });
  // Sphère de marques : positionnement en coordonnées sphériques et suivi discret du pointeur.
  document.querySelectorAll('[data-coc-globe]').forEach(globe=>{
    const core=globe.querySelector('[data-coc-globe-core]');
    if(!core)return;
    const tiles=[...globe.querySelectorAll('[data-coc-globe-item]')];
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let x=-10,y=0,targetX=-10,targetY=0,active=false,frame=null;
    function geometry(){
      const radius=Math.min(globe.clientWidth*.35,168);
      const n=tiles.length;
      tiles.forEach((tile,i)=>{
        // Fibonacci sphere: coverage uniform over the entire ball.
        const z=1-2*(i+.5)/Math.max(1,n);
        const polar=Math.acos(Math.max(-1,Math.min(1,z)));
        const azimuth=i*2.399963229728653;
        const px=Math.sin(polar)*Math.cos(azimuth)*radius;
        const py=Math.cos(polar)*radius;
        const pz=Math.sin(polar)*Math.sin(azimuth)*radius;
        tile.style.transform=`translate3d(calc(-50% + ${px}px),calc(-50% + ${py}px),${pz}px)`;
      });
    }
    function render(){
      x+=(targetX-x)*.06; y+=(targetY-y)*.06;
      core.style.transform=`rotateX(${x.toFixed(2)}deg) rotateY(${y.toFixed(2)}deg)`;
      if(!active && !reducedMotion.matches)targetY+=.09;
      if(!reducedMotion.matches)frame=requestAnimationFrame(render);
    }
    globe.addEventListener('pointermove',e=>{
      if(reducedMotion.matches || e.pointerType==='touch')return;
      const r=globe.getBoundingClientRect();
      const dx=((e.clientX-r.left)/r.width)-.5;
      const dy=((e.clientY-r.top)/r.height)-.5;
      targetY=y+dx*3.8;targetX=Math.max(-36,Math.min(36,-10-dy*24));active=true;
    });
    globe.addEventListener('pointerleave',()=>{active=false;targetX=-10;});
    geometry();
    if(!reducedMotion.matches)render();
    window.addEventListener('resize',geometry,{passive:true});
    document.addEventListener('shopify:section:unload',()=>{if(frame)cancelAnimationFrame(frame);},{once:true});
  });
})();
